import { render } from "./DataInfo.vue?vue&type=template&id=e2b28efa&scoped=true"
import script from "./DataInfo.vue?vue&type=script&lang=js"
export * from "./DataInfo.vue?vue&type=script&lang=js"

import "./DataInfo.vue?vue&type=style&index=0&id=e2b28efa&scoped=true&lang=scss"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2b28efa"]])

export default __exports__